(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["passende-produkte"] && !Shopify.designMode) return;
  try {
    (() => {
    if (customElements.get('pp-products-carousel')) return;

    class PPProductsCarousel extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-pp-track]');
        this.prevBtn = this.querySelector('[data-pp-prev]');
        this.nextBtn = this.querySelector('[data-pp-next]');
        if (!this.track) return;

        this.update = this.update.bind(this);
        if (this.prevBtn) this.prevBtn.addEventListener('click', () => this.scrollByCard(-1));
        if (this.nextBtn) this.nextBtn.addEventListener('click', () => this.scrollByCard(1));
        this.track.addEventListener('scroll', this.update, { passive: true });
        this.resizeObserver = new ResizeObserver(this.update);
        this.resizeObserver.observe(this.track);
        this.update();
      }

      disconnectedCallback() {
        if (this.resizeObserver) this.resizeObserver.disconnect();
      }

      scrollByCard(dir) {
        const card = this.track.querySelector('[data-pp-card]');
        let amount = this.track.clientWidth;
        if (card) {
          const gap = parseFloat(getComputedStyle(this.track).columnGap) || 12;
          amount = card.getBoundingClientRect().width + gap;
        }
        this.track.scrollBy({ left: dir * amount, behavior: 'smooth' });
      }

      update() {
        if (!this.track) return;
        const maxScroll = this.track.scrollWidth - this.track.clientWidth;
        this.toggleAttribute('data-overflow', maxScroll > 4);
        if (this.prevBtn) this.prevBtn.disabled = this.track.scrollLeft <= 4;
        if (this.nextBtn) this.nextBtn.disabled = this.track.scrollLeft >= maxScroll - 4;
      }
    }

    customElements.define('pp-products-carousel', PPProductsCarousel);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["product-badges"] && !Shopify.designMode) return;
  try {
    // Leere Blöcke/Gruppen in der Produktinfo kollabieren (sonst erzeugen sie Flex-Gaps).
  // Beobachtet den DOM und blendet wieder ein, sobald Inhalt nachgeladen wird (z.B. Bewertungssterne).
  (function () {
    if (window.Shopify && Shopify.designMode) return;
    var MEDIA = 'img,svg,video,iframe,canvas,picture,input,select,textarea,button,form';
    function istLeer(el) {
      return el.textContent.trim() === '' && !el.querySelector(MEDIA);
    }
    function sweep() {
      document.querySelectorAll('.product-information .shopify-block, .product-information .group-block').forEach(function (el) {
        el.toggleAttribute('data-leer-ausblenden', istLeer(el));
      });
    }
    var geplant = false;
    function planeSweep() {
      if (geplant) return;
      geplant = true;
      requestAnimationFrame(function () { geplant = false; sweep(); });
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', sweep);
    } else {
      sweep();
    }
    new MutationObserver(planeSweep).observe(document.body, { childList: true, subtree: true, characterData: true });
  })();
  } catch(e) { console.error(e); }
})();

})();
